//
//
//
//
//
//
//
//

export default {
  props: {
    country: { type: String, required: true },
    size: { type: Number, default: 40 }
  }
}
